/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { SideBar } from "components/header/side-bar";
import SpinnerBackdrop from "components/spinner-backdrop";
import { API_ERROR_CODE } from "constants/api.constants";
import { AppEnvVariables, ENV_VARS } from "constants/environment.constants";
import { getCookie } from "helpers/storageHelper";
import { withAuthorization } from "hoc";
import { odsToastNotification, ODSToastNotificationContainer } from "kfone-component-library";
import {
  ToastNotificationPosition,
  ToastNotificationVariant
} from "kfone-component-library/enums";
import "kfone-component-library/font-faces.css";
import "kfone-component-library/style.css";
import {
  KF1AppRootProvider,
  kf1AuthenticatedHttpClient,
} from "kfone-frontend-core";
import { ILanguageProviderProps } from "kfone-frontend-core/interfaces";
import { GlobalNavEventName, KF1GlobalNav } from "kfone-react-web-component";
import { TRANSLATION_ID } from "model/constants/shared";
import type { FC } from "react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetStateClient } from "store/slices/clientSelectionSlice";
import { resetState } from "store/slices/countryDetailsSlice";
import {
  resetFilters,
  resetFiltersCount,
  resetJobCatogery,
  resetJobPricingList,
  resetPeerGroupId,
  resetSearchKey,
  resetSelectedPeerGroup
} from "store/slices/SJPR/listSlice";

import { resetConfigState } from "store/slices/configSlice";

import { resetCurrencyState } from "store/slices/currencyDetailsSlice";

import { DEFAULT_LANGUAGE_CODE, DEFAULT_LANGUAGE_FULL_CODE, REFRESH_AUTH_TOKEN_INTERVEL } from "constants/common.constants";
import { SESSION_STORAGE_VAR } from "constants/session-variables.constants";
import { useIdleTimer } from "react-idle-timer";
import { KfSessionBaggageInterceptor } from "services/datadog";
import { refreshAuthToken } from "services/Service";
import { useCommonStore } from "store";
import { resetState as resetFilterState } from "store/slices/filtersSlice";
import { resetReportDetailsState } from "store/slices/jobPricingDetailsSlice";
import { resetReportSearchState } from "store/slices/jobPricingSearchSlice";
import { resetJobPricingState } from "store/slices/jobPricingSlice";
import { resetState as resetReportsState } from "store/slices/reportsSlice";
import { resetState as resetUserState } from "store/slices/userSlice";
import { initDataDogRum } from "utilities/data-dog-rum";
import "./assets/scss/global.scss";
import GlobalRouter from "./router";
import { getLanguages } from "./shared/locales";
const App: FC = () => {
  const initialTranslationId = getCookie('__kfone_i18n_primary_lng')
  const loadedLocaleRef = useRef<string | null>(null);

  const [languageProps, setLanguageProps] = useState<ILanguageProviderProps | null>(
    null,
  );
  const [isLanguageLoading, setIsLanguageLoading] = useState(true);

  const { updateSpinnerShow } = useCommonStore();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isloggedIn, setIsLoggedIn] = useState(false);
  const [show, setShow] = useState(false);

  // Execute blow code sinppet only for local developement to update the authToken for API
  // if ((window.location.hostname === 'localhost' && window.location.port === '3090') ||
  //   (window.location.hostname === 'payanalytics.kornferrytalent-dev.com') ||
  //   (window.location.hostname === 'payanalytics.kornferrytalent-qa.com')) { // this is for local testing and QA environment
  //   kf1AuthenticatedHttpClient.interceptors.request.use((config) => {
  //     const authToken = sessionStorage.getItem(SESSION_STORAGE_VAR.localAuthToken);
  //     if (authToken) {
  //       config.headers.Authorization = `Bearer ${authToken}`;
  //     }
  //     return config;
  //   });
  // }
  const [timer, setTimer] = useState<Date>(new Date());

  const interval = REFRESH_AUTH_TOKEN_INTERVEL * 60 * 1000;
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const handleOnIdle = () => {
    //idle already taken care in session model
  };

  useEffect(() => {
    handleLanguageChange(DEFAULT_LANGUAGE_CODE);
  }, []);
  
  const handleOnAction = (event: any) => {
    setTimer(new Date());
  };

  useIdleTimer({
    timeout: 1000 * 60 * REFRESH_AUTH_TOKEN_INTERVEL, // 10 minutes
    onIdle: handleOnIdle,
    onActive: handleOnAction,
    debounce: 500,
    startOnMount: true
  });

  const resetAllStores = () => {
    dispatch(resetState());
    dispatch(resetFilters());
    dispatch(resetFiltersCount());
    dispatch(resetJobCatogery());
    dispatch(resetJobPricingList());
    dispatch(resetSearchKey());
    dispatch(resetPeerGroupId());
    dispatch(resetSelectedPeerGroup());
    dispatch(resetStateClient());

    dispatch(resetConfigState());

    dispatch(resetCurrencyState());
    dispatch(resetFilterState());
    dispatch(resetReportDetailsState());
    dispatch(resetReportSearchState());

    dispatch(resetJobPricingState());

    dispatch(resetReportsState());

    dispatch(resetUserState());
  };

  const autoLogin = () => {
    updateSpinnerShow(true);

    const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (navEntry?.type === "navigate") {
      resetAllStores();
    }

    let activeClient: any = getCookie("__kfone_active_client");
    activeClient = activeClient
      ? JSON.parse(decodeURIComponent(activeClient))
      : null;
    const prevClient = sessionStorage.getItem("activeClient");
    if (activeClient?.name != prevClient) {
      resetAllStores();
      sessionStorage.setItem("activeClient", activeClient?.name);
    }

    const refreshToken: any = getCookie("__kfone_refresh_token");
    const accessToken: any = getCookie("__kfone_access_token");
    const localToken = sessionStorage.getItem(
      SESSION_STORAGE_VAR.localAuthToken
    );
    let authToken: string = accessToken ?? localToken;
    if (authToken) {
      sessionStorage.setItem(
        SESSION_STORAGE_VAR.refreshToken,
        refreshToken ?? authToken
      ); // if refresh token not found in cookie use default authtoken
      updateAuth(authToken);
      setIsLoggedIn(true);
      updateSpinnerShow(false);
      if (ENV_VARS.DATADOG_RUM_ENABLED === "true") {
        // void initDataDogRum();
      }
    } else {
      logout();
      setIsLoggedIn(false);
      updateSpinnerShow(false);
    }
  };

  const updateAuth = (authToken: string) => {
    kf1AuthenticatedHttpClient.interceptors.request.clear();
    kf1AuthenticatedHttpClient.interceptors.request.use((config) => {
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
        sessionStorage.setItem(SESSION_STORAGE_VAR.localAuthToken, authToken);
      }
      config = KfSessionBaggageInterceptor(config);
      if (!config?.hideSpinner) {
        updateSpinnerShow(true);
      }
      return config;
    });
  };

  // useEffect(() => {
  //   const locale = initialTranslationId || DEFAULT_LANGUAGE_CODE;
  //   loadedLocaleRef.current = locale;
  //   void handleLanguageChange(locale);
  // }, []);

  useEffect(() => {
    void autoLogin();
    //handle app specific errors and 401 redirect and logout user
    kf1AuthenticatedHttpClient.interceptors.response.use(
      (response) => {
        if (!response?.config?.hideSpinner) {
          updateSpinnerShow(false);
        }
        return response;
      },
      (error) => {
        if (!error?.config?.hideSpinner) {
          updateSpinnerShow(false);
        }
        console.log("ERROR in interceptor", error);
        if (error?.status === API_ERROR_CODE.unAuthorized) {
          logout();
        }
        return error;
      }
    );
  }, []);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(async () => {
      if (timer) {
        var endTime = new Date();
        var difference = endTime.getTime() - timer.getTime(); // This will give difference in milliseconds
        var idleTime = Math.round(difference / 60000);
        if (idleTime < REFRESH_AUTH_TOKEN_INTERVEL) {
          //Need to refresh authtoken
          const res: any = await refreshAuthToken(); // refresh token if user is not active within 15 minutes
          // timerRef.current = new Date();
          if (res?.access_token) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            updateAuth(res.access_token);
            sessionStorage.setItem(
              SESSION_STORAGE_VAR.refreshToken,
              res?.refresh_token
            );
          }
        }
      }
    }, interval); // update token in interval
  }, []);

  const handleGlobalNavEvent = ({
    eventName,
    data
  }: {
    eventName: string;
    data?: any;
  }) => {
    switch (eventName as GlobalNavEventName) {
      case GlobalNavEventName.SignOut:
        // navigate(CommonRoutes.Logout);
        resetAllStores();
        setTimeout(() => logout(), 1000); //since reset not happening
        break;
      case GlobalNavEventName.Notification:
        odsToastNotification({
          description: data?.message,
          variant: data?.variant as ToastNotificationVariant,
          options: {
            position: ToastNotificationPosition.TopRight
          }
        });

       
        break;
      case GlobalNavEventName.Preferences: {
        let localeIdentifier: any = data?.localeIdentifier as string | undefined;
        if (!localeIdentifier) {
          localeIdentifier = DEFAULT_LANGUAGE_CODE;
        };

        // GlobalNav emits Preferences on mount and again after the LanguageProvider
        // mounts, sometimes with different casing/separators for the same locale
        // (e.g. "en_US" vs "en-US"). Normalize so we don't reload/re-fetch for what
        // is effectively the same language.
        const normalizedLocale = localeIdentifier.trim().replace(/_/g, "-").toLowerCase();
        if (loadedLocaleRef.current === normalizedLocale) break;

        loadedLocaleRef.current = normalizedLocale;
        // Apply the language in place instead of doing a full page reload, so the
        // user stays on their current route rather than being sent back to the
        // landing page.
        void handleLanguageChange(localeIdentifier);
        break;
      }
      case GlobalNavEventName.Navigate:
        navigate(data?.path as string);
        break;
    }
  };

  const handleLanguageChange = async (localeIdentifier: string) => {
    setIsLanguageLoading(true);
    try {
      const resources = await getLanguages(localeIdentifier);
      setLanguageProps({
        resources,
        // Vary the translationId per locale so the underlying LanguageProvider
        // re-applies the freshly fetched resources without needing a full page
        // reload (it skips re-init when the translationId is unchanged).
        translationId: `${TRANSLATION_ID}-${localeIdentifier}`,
      });
    } finally {
      setIsLanguageLoading(false);
    }
  };

  const logout = () => {
    if (
      !(
        window.location.hostname === "localhost" &&
        window.location.port === "3090"
      )
    ) {
      sessionStorage.removeItem(SESSION_STORAGE_VAR.localAuthToken);
      window.location.href = AppEnvVariables?.KF_TALENT_SUITE + "/logout";
    }
  };

  return (
    <KF1AppRootProvider languageProps={languageProps ?? undefined} >
      <div className="h-lvh">
        <KF1GlobalNav
          onGlobalNavEvent={(
            event: CustomEvent<{ eventName: string; data?: any }>
          ) => {
            handleGlobalNavEvent(event?.detail);
          }}
        />
        {isloggedIn && <SideBar show={show} toggle={() => setShow(!show)} />}
        <div className="relative top-[48px] z-[4] pl-[66px]">
          {!isloggedIn ? (
            <SpinnerBackdrop />
          ) : isLanguageLoading ? (
            <div className="flex h-[calc(100vh-48px)] w-full items-center justify-center">
              <svg
                aria-hidden="true"
                className="inline h-10 w-10 animate-spin fill-ods-color-brand-primary-600 text-gray-200"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          ) : (
            <GlobalRouter />
          )}
        </div>
        <SpinnerBackdrop />
        <ODSToastNotificationContainer
          className='z-100'
          position={ToastNotificationPosition.TopRight}
        />
      </div>
    </KF1AppRootProvider>
  );
};

const AppComponentWithAuthorization = withAuthorization(App);
AppComponentWithAuthorization.displayName = "AppComponentWithAuthorization";

export default AppComponentWithAuthorization;
